import { incaAccessor } from './incaAccessor.js';
/**
 * Gets VD. The result is mapped to the same format as for forms: id and text instead of value and displayText.
 *
 * @param {string} shortname - Name of the vd.
 * @param {object} options   - Settings.
 *
 * @returns {Promise}
 */ export const getValueDomainValues = (shortname, options)=>{
    const inca = incaAccessor();
    if (!inca?.services?.startPage?.getValueDomainValues) {
        throw new Error('Could not find inca.services.startPage.getValueDomainValues.');
    }
    const parameters = options?.parameters || {};
    return new Promise((resolve, reject)=>{
        inca.services.startPage.getValueDomainValues({
            shortname: shortname,
            parameters: options?.parameters ? Object.keys(parameters).reduce((reduction, key)=>{
                const val = parameters[key];
                reduction[key] = Array.isArray(val) ? val : [
                    val
                ];
                return reduction;
            }, {}) : undefined,
            filters: options?.filters,
            success (res) {
                const goodRes = res.map((x)=>{
                    return {
                        data: x.data,
                        id: x.value,
                        text: x.displayText
                    };
                });
                resolve(goodRes);
            },
            error: reject
        });
    });
};
